/**
 * 用户授权手机号后实现免登
 * */

import * as dd from "dingtalk-jsapi";
import { openAuth } from "dingtalk-design-libs/biz/openAuth";

// const config = {
//     appKey:"suitebzehwe24k3rjfgyo",
//     authCorpId:"ding929de0f8d59f7c18f5bf40eda33b7ba0"
// }
export default async function loginFree(vm) {
    const _this = vm;
    const config = await _this.getApolloConfig("insure.dingTalk.config");
    console.log("loginFree");
    return new Promise(async (resolve, reject) => {
        // 个人
        const res = await openAuth({
            clientId: config.appKey,
            corpId: config.authCorpId,
            rpcScope: "Contact.User.Read",
            fieldScope: "Contact.User.mobile",
            type: 0,
        });
        const { result } = res;
        dd.ready(function () {
            dd.runtime.permission.requestAuthCode({
                corpId: config.authCorpId,
                onSuccess: async function (info) {
                    const userInfo = await _this.$axios.post(
                        "/thirdChannel/authentication.do",
                        {
                            token: JSON.stringify({
                                code: info.code,
                                authCode: result.authCode,
                            }),
                            channelId: "ZOQrE9DzjD5VRz7v",
                        }
                    );
                    sessionStorage.setItem('userId',userInfo.userId)
                    resolve(userInfo);
                },
                onFail: reject,
            });
        });
    });
}



// WEBPACK FOOTER //
// ./src/common/loginFree.js